import styled from '@emotion/styled';

import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';
import { MainButtonHeight } from '../../styledComponent/Buttons.style';
import { css } from '@emotion/react';

const MobileButtonWrapperHeight = MainButtonHeight + 32; // height + padding offset
const DesktopPaddingVertical = 100;

export const InfoV2Ver2Screen = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: ${DesktopPaddingVertical}px 90px;
  background-color: ${getColor('BEIGE_5')};

  @media (max-width: ${TabletWidth}px) {
    background-color: ${getColor('BEIGE_10')};
    padding: 42px 0px 24px;
  }
`;

export const InfoV2Ver2ScreenDesktop = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: left;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const InfoV2Ver2ScreenDesktopLeft = styled.div`
  width: 50%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: left;
`;

export const InfoV2Ver2ScreenDesktopRight = styled.div<{ imageFullSize?: boolean; withCarousel?: boolean }>`
  width: 50%;
  height: ${({ imageFullSize }) => (imageFullSize ? `calc(100% + ${2 * DesktopPaddingVertical}px)` : '100%')};
  align-content: center;
  max-height: ${({ withCarousel }) => (withCarousel ? 'min(80vh, 740px)' : 'unset')};
`;

export const InfoV2Ver2ScreenMobileTextWrapper = styled.div`
  @media (max-width: ${TabletWidth}px) {
    margin: 0 auto auto;
    padding-right: 24px;
    padding-left: 24px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: flex-start;
  }

  @media (max-height: 650px) {
    min-height: unset;
    margin-top: auto;
  }
`;

export const InfoV2Ver2ScreenContentWrapper = styled.div<{ withCarousel?: boolean }>`
  max-width: 460px;
  text-align: left;

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    text-align: center;
    height: calc(100% - ${MobileButtonWrapperHeight}px);
    overflow: hidden;
    display: ${({ withCarousel }) => (withCarousel ? 'grid' : 'flex')};
    grid-template-rows: 1fr max-content;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const InfoV2Ver2ScreenSection = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: ${getColor('GRAY_80')};
  margin-bottom: 42px;

  @media (max-width: ${TabletWidth}px) {
    text-align: center;
    margin-bottom: 12px;
  }
`;

export const InfoV2Ver2ScreenTitle = styled.h3`
  font-family: Lora;
  font-size: 42px;
  font-weight: 600;
  line-height: 48px;
  color: ${getColor('GRAY_95')};
  margin-bottom: 8px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 28px;
    line-height: 32px;
    max-width: 330px;
    margin: 0 auto;
  }
`;

export const InfoV2Ver2ScreenDescription = styled.p`
  font-family: Lora;
  font-size: 18px;
  font-weight: 500;
  color: ${getColor('GRAY_95')};
  max-width: 330px;
  text-align: left;

  @media (max-width: ${TabletWidth}px) {
    text-align: center;
    max-width: 100%;
  }
`;

export const InfoV2Ver2ScreenButtonWrapper = styled.div`
  margin-top: 52px;
  width: 205px;

  @media (max-width: ${TabletWidth + 1}px) {
    width: 100%;
  }
`;

export const InfoV2Ver2ScreenImgDesktop = styled.div<{ img: string; imageFullSize?: boolean; isCentered?: boolean }>`
  background-image: url(${({ img }) => img});
  height: 95%;
  width: 65%;
  background-repeat: no-repeat;
  background-position: ${({ isCentered }) => (isCentered ? 'center' : 'center bottom')};
  background-size: contain;
`;

export const InfoV2Ver2ScreenImgDesktopWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${getColor('BEIGE_10')};
  border-radius: 32px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  max-width: 580px;
  max-height: 695px;
  margin-left: auto;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 31%;
    background: linear-gradient(transparent 0%, ${getColor('BEIGE_10')} 100%);
  }
`;

export const InfoV2Ver2ScreenMobile = styled.div`
  width: 100%;
  height: 100%;

  @media (min-width: ${TabletWidth + 1}px) {
    display: none;
  }
`;

export const InfoV2Ver2ScreenMobileImgWrapper = styled.div<{ withCarousel?: boolean }>`
  position: relative;
  overflow: hidden;
  max-width: ${({ withCarousel }) => (withCarousel ? '100%' : 'min(320px, 100%)')};

  ${({ withCarousel }) =>
    withCarousel
      ? css`
          @media (max-width: ${TabletWidth}px) {
            height: 120%;
          }

          @media (max-width: 375px) {
            height: 123%;
          }

          @media (max-height: 650px) {
            height: 100%;
          }
        `
      : css`
          @media (max-height: 650px) {
            margin-top: 16px;
          }
        `}
`;

export const InfoV2Ver2ScreenMobileGradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 48px;
  background: linear-gradient(transparent 0%, #f0eae4 100%);
`;

export const InfoV2Ver2ScreenImgMobile = styled.img`
  width: 100%;
  object-fit: contain;

  @media (max-width: ${TabletWidth}px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const InfoV2Ver2ScreenMobileButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 16px;

  @media (max-width: ${TabletWidth}px) {
    padding-left: 24px;
    padding-right: 24px;
    max-width: min(320px, 100%);
    margin: 0 auto;
  }
`;
